__turbopack_context__.v({
  "arrowBtn": "dental-module__y9QTwG__arrowBtn",
  "audioAgentName": "dental-module__y9QTwG__audioAgentName",
  "audioAgentStatus": "dental-module__y9QTwG__audioAgentStatus",
  "audioAvatar": "dental-module__y9QTwG__audioAvatar",
  "audioLabel": "dental-module__y9QTwG__audioLabel",
  "audioPlayBtn": "dental-module__y9QTwG__audioPlayBtn",
  "audioPlayIcon": "dental-module__y9QTwG__audioPlayIcon",
  "audioStatusDot": "dental-module__y9QTwG__audioStatusDot",
  "audioStatusDotActive": "dental-module__y9QTwG__audioStatusDotActive",
  "audioWaveBar": "dental-module__y9QTwG__audioWaveBar",
  "audioWaveBarActive": "dental-module__y9QTwG__audioWaveBarActive",
  "audioWaveform": "dental-module__y9QTwG__audioWaveform",
  "audioWidget": "dental-module__y9QTwG__audioWidget",
  "audioWidgetHeader": "dental-module__y9QTwG__audioWidgetHeader",
  "ctaBtn": "dental-module__y9QTwG__ctaBtn",
  "ctaImage": "dental-module__y9QTwG__ctaImage",
  "ctaInner": "dental-module__y9QTwG__ctaInner",
  "ctaOverlay": "dental-module__y9QTwG__ctaOverlay",
  "ctaSection": "dental-module__y9QTwG__ctaSection",
  "ctaSubtitle": "dental-module__y9QTwG__ctaSubtitle",
  "ctaTitle": "dental-module__y9QTwG__ctaTitle",
  "fcIllusArea": "dental-module__y9QTwG__fcIllusArea",
  "fcPulse": "dental-module__y9QTwG__fcPulse",
  "fcSubtitle": "dental-module__y9QTwG__fcSubtitle",
  "fcTextArea": "dental-module__y9QTwG__fcTextArea",
  "fcTitle": "dental-module__y9QTwG__fcTitle",
  "fcWave": "dental-module__y9QTwG__fcWave",
  "featureCard": "dental-module__y9QTwG__featureCard",
  "featuresGrid": "dental-module__y9QTwG__featuresGrid",
  "featuresInner": "dental-module__y9QTwG__featuresInner",
  "featuresSection": "dental-module__y9QTwG__featuresSection",
  "hero": "dental-module__y9QTwG__hero",
  "heroBtnPrimary": "dental-module__y9QTwG__heroBtnPrimary",
  "heroBtnSecondary": "dental-module__y9QTwG__heroBtnSecondary",
  "heroBtns": "dental-module__y9QTwG__heroBtns",
  "heroContent": "dental-module__y9QTwG__heroContent",
  "heroImage": "dental-module__y9QTwG__heroImage",
  "heroLayout": "dental-module__y9QTwG__heroLayout",
  "heroOverlay": "dental-module__y9QTwG__heroOverlay",
  "heroSubtitle": "dental-module__y9QTwG__heroSubtitle",
  "heroTag": "dental-module__y9QTwG__heroTag",
  "heroTitle": "dental-module__y9QTwG__heroTitle",
  "howItWorksHeader": "dental-module__y9QTwG__howItWorksHeader",
  "howItWorksSection": "dental-module__y9QTwG__howItWorksSection",
  "howSubtitle": "dental-module__y9QTwG__howSubtitle",
  "howTitle": "dental-module__y9QTwG__howTitle",
  "howTitleItalic": "dental-module__y9QTwG__howTitleItalic",
  "illusAgent": "dental-module__y9QTwG__illusAgent",
  "illusApptCard": "dental-module__y9QTwG__illusApptCard",
  "illusApptConfirm": "dental-module__y9QTwG__illusApptConfirm",
  "illusApptRow": "dental-module__y9QTwG__illusApptRow",
  "illusApptTitle": "dental-module__y9QTwG__illusApptTitle",
  "illusCallBadge": "dental-module__y9QTwG__illusCallBadge",
  "illusCallDot": "dental-module__y9QTwG__illusCallDot",
  "illusCallNumber": "dental-module__y9QTwG__illusCallNumber",
  "illusCallWrap": "dental-module__y9QTwG__illusCallWrap",
  "illusDoc": "dental-module__y9QTwG__illusDoc",
  "illusDocBack1": "dental-module__y9QTwG__illusDocBack1",
  "illusDocBack2": "dental-module__y9QTwG__illusDocBack2",
  "illusDocFront": "dental-module__y9QTwG__illusDocFront",
  "illusDocIcon": "dental-module__y9QTwG__illusDocIcon",
  "illusInsBadge": "dental-module__y9QTwG__illusInsBadge",
  "illusInsCard": "dental-module__y9QTwG__illusInsCard",
  "illusInsRow": "dental-module__y9QTwG__illusInsRow",
  "illusInsTitle": "dental-module__y9QTwG__illusInsTitle",
  "illusLangBubble": "dental-module__y9QTwG__illusLangBubble",
  "illusLangTag": "dental-module__y9QTwG__illusLangTag",
  "illusLangText": "dental-module__y9QTwG__illusLangText",
  "illusLangWrap": "dental-module__y9QTwG__illusLangWrap",
  "illusLive": "dental-module__y9QTwG__illusLive",
  "illusLiveBadge": "dental-module__y9QTwG__illusLiveBadge",
  "illusLiveDot": "dental-module__y9QTwG__illusLiveDot",
  "illusLiveList": "dental-module__y9QTwG__illusLiveList",
  "illusPanel": "dental-module__y9QTwG__illusPanel",
  "illusPanelLabel": "dental-module__y9QTwG__illusPanelLabel",
  "illusPanelOn": "dental-module__y9QTwG__illusPanelOn",
  "illusPanelRow": "dental-module__y9QTwG__illusPanelRow",
  "illusPanelValue": "dental-module__y9QTwG__illusPanelValue",
  "illusPhone": "dental-module__y9QTwG__illusPhone",
  "illusPhoneBadge": "dental-module__y9QTwG__illusPhoneBadge",
  "illusPhoneLabel": "dental-module__y9QTwG__illusPhoneLabel",
  "illusPhoneNum": "dental-module__y9QTwG__illusPhoneNum",
  "illusStack": "dental-module__y9QTwG__illusStack",
  "illusTreatBadge": "dental-module__y9QTwG__illusTreatBadge",
  "illusTreatCard": "dental-module__y9QTwG__illusTreatCard",
  "illusTreatRow": "dental-module__y9QTwG__illusTreatRow",
  "illusTreatTitle": "dental-module__y9QTwG__illusTreatTitle",
  "illusVerifyBadge": "dental-module__y9QTwG__illusVerifyBadge",
  "illusVerifyCard": "dental-module__y9QTwG__illusVerifyCard",
  "illusVerifyRow": "dental-module__y9QTwG__illusVerifyRow",
  "illusVerifyTitle": "dental-module__y9QTwG__illusVerifyTitle",
  "illusWaveBar": "dental-module__y9QTwG__illusWaveBar",
  "illusWaveBars": "dental-module__y9QTwG__illusWaveBars",
  "livePulse": "dental-module__y9QTwG__livePulse",
  "page": "dental-module__y9QTwG__page",
  "sectionHeader": "dental-module__y9QTwG__sectionHeader",
  "sectionLabel": "dental-module__y9QTwG__sectionLabel",
  "slideCard": "dental-module__y9QTwG__slideCard",
  "slideCard1": "dental-module__y9QTwG__slideCard1",
  "slideCard2": "dental-module__y9QTwG__slideCard2",
  "slideCard3": "dental-module__y9QTwG__slideCard3",
  "slideCard4": "dental-module__y9QTwG__slideCard4",
  "slideDesc": "dental-module__y9QTwG__slideDesc",
  "slideIllus": "dental-module__y9QTwG__slideIllus",
  "slideNum": "dental-module__y9QTwG__slideNum",
  "slideText": "dental-module__y9QTwG__slideText",
  "slideTitle": "dental-module__y9QTwG__slideTitle",
  "sliderArrows": "dental-module__y9QTwG__sliderArrows",
  "sliderViewport": "dental-module__y9QTwG__sliderViewport",
});
